import React from 'react';
import { hydrate } from 'react-dom';
import { Provider as ReduxStoreProvider } from 'react-redux';

import App from './common/App/App';

import { AppConfigProvider } from './hooks/useAppConfig';
import { RouterProvider, createHistory } from './hooks/useRouter';

import { ClientContext } from './types';

import createStore from './store';
import routes from './routes';
import { createAppConfig } from './config/createAppConfig';
import { RoutesProvider } from './hooks/useRoutes';

export default (clientContext: ClientContext) => {
  //  Builds on the config by substituting values
  //  that are only available from the client side
  const config = createAppConfig(clientContext);
  const store = createStore(config);
  const history = createHistory();

  hydrate(
    <ReduxStoreProvider store={store}>
      <RouterProvider
        routes={[
          ...routes.unrestricted,
          routes.recommendedCandidates,
          ...routes.restricted,
        ]}
        history={history}
      >
        <AppConfigProvider config={config}>
          <RoutesProvider
            environment={config.ENVIRONMENT}
            locale={config.LOCALE}
            site={config.SITE}
          >
            <App routes={routes} />
          </RoutesProvider>
        </AppConfigProvider>
      </RouterProvider>
    </ReduxStoreProvider>,
    document.getElementById('app'),
  );
};
